<template>
    <v-layout row wrap>
        <div class="s-buttons-wrap">
            <div class="m-onboard-step-buttons employee-buttons">
                <div class="m-onboard-header__btn-skip">
                    <e-typography-bold @click="next" tabindex="0">
                        {{$t('modules.onboards.m-onboard-step-employee.skip')}}
                    </e-typography-bold>
                </div>
                <e-button-white @click="submitChild" class="mr-0">
                    {{$t('modules.onboards.m-onboard-step-employee.save-and-continue')}}
                </e-button-white>
            </div>
        </div>

        <v-flex xs12>
            <v-expansion-panel class="m-onboard-step-employee__expansion-panel" v-model="panelState">
                <v-expansion-panel-content>
                    <div class="m-onboard-step-employee">
                        <div class="content-border-area">
                            <m-form-user :action="passAction" @next="next" @resetAction="resetAction" isOnboarding/>
                        </div>
                        <v-layout class="m-onboard-step-employee__btn mt-3" justify-end>
                            <e-button-secondary @click="next" class="mobile-skip" tabindex="0">
                                {{$t('modules.onboards.m-onboard-step-employee.skip')}}
                            </e-button-secondary>
                            <e-button-primary @click="submitChild">
                                {{$t('modules.onboards.m-onboard-step-employee.save-and-continue')}}
                            </e-button-primary>
                        </v-layout>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>

        </v-flex>
    </v-layout>
</template>

<script>

    // IE11 Fix
    if (!('remove' in Element.prototype)) {
        Element.prototype.remove = function() {
            if (this.parentNode) {
                this.parentNode.removeChild(this);
            }
        };
    }

    import MFormUser from "@modules/forms/concrete/m-form-user";

    export default {
        name: "m-onboard-step-employee",
        components: {MFormUser},
        data() {
            return {
                panelState: 0,
                passAction: ''
            }
        },
        methods: {
            submitChild() {
                this.passAction = "submit"
            },
            resetAction() {
                this.passAction = ""
            },
            next() {
                this.$emit('next')
            },
            placeButtons() {
                let removeButtons = document.querySelector('.object-buttons');
                let addButtons = document.querySelector('.employee-buttons');
                let target = document.querySelector('.m-onboard-header-buttons');
                if (document.body.contains(removeButtons)) removeButtons.remove();
                target.appendChild(addButtons)
            }
        },
        mounted() {
            this.placeButtons();
        },
        updated() {
            this.placeButtons()
        }
    }
</script>

<style lang="scss">
    .m-onboard-header__btn-skip {
        padding-left: 1rem;
        @include updatedMedia(md) {
            padding-left: 1rem;
        }

        &:hover {
            text-decoration: underline;
            color: var(--v-white);
        }
    }

    .m-onboard-step-employee {
        &__btn {
            @include media(md) {
                padding-top: 1rem;
                display: inline-block;
                margin: 0 auto !important;
                width: 95%;
                justify-content: center;
            }
        }

        &__expansion-panel {
            box-shadow: none;

            .v-expansion-panel {
                &__body {
                    background: var(--v-secondary-base);
                }
            }
        }
    }

    .m-onboard-step-employee__btn {
        @media (max-width: $md) {
            flex-direction: column;
        }
        @media (min-width: $md) {
            .mobile-skip {
                display: none;
            }
        }
    }

    .fullscreen {
        .m-onboard-step-employee {
            .v-divider {
                display: none;
            }

            .m-form {
                padding: 0 !important;
                padding: 1rem;
                border-radius: 3px;
                -webkit-box-shadow: 0px 1px 6px 0px rgba(0, 73, 148, 0.61);
                box-shadow: 0px 1px 6px 0px rgba(0, 73, 148, 0.61);

                @include media(md) {
                    padding: 1rem !important;
                }
            }

            .content-border-area {
                box-shadow: none;
                padding: 0;

                @media (max-width: $md) {
                    padding-left: 0 !important;
                }
             }
        }

        .m-onboard-step-employee__expansion-panel {
            .v-expansion-panel__container {
                background-color: transparent;
            }
        }
    }


</style>